import React, { useState, useEffect } from "react";
import "../../styles/Containers.css";
import "../../styles/Fonts.css";
import "../../styles/Inputs.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as LoginIllus } from "../../media/LoginIllus.svg";
import { useFetch } from "../../custom/api";
import GoToTop from "../../components/GoToTop";
import { PENDING_INVITE_KEY } from "../groups/groupApi";
// import { getFirebaseToken } from "../../custom/fireBase";

function Login() {
  const { myFetch } = useFetch();
  const navigate = useNavigate();
  const location = useLocation();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [showVerification, setShowVerification] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [varificationCodeError, setVarificationCodeError] = useState("");
  // const [hasFirebaseToken, setHasFirebaseToken] = useState(false);
  const [timer, setTimer] = useState(0); // Set the initial timer value to 120 seconds
  const [loading, setLoading] = useState(false);

  const handlePhoneChange = (event) => {
    setPhoneNumber(event.target.value);
  };

  const handleVerificationCodeChange = (event) => {
    setVerificationCode(event.target.value);
  };

  const handleSendVerification = async (event) => {
    event.preventDefault();
    setLoading(true);
    // validate phone number
    if (!phoneNumber) {
      setLoading(false);
      setPhoneNumberError("شماره رو با 09 شروع کن");
      return;
    }

    // validate phone number format
    const phoneRegex = /^09\d{9}$/;
    if (!phoneRegex.test(phoneNumber)) {
      setLoading(false);
      setPhoneNumberError(" شماره باید با 09 شروع بشه و 11 رقمی باشه");
      return;
    }
    // validate existance in database

    const response = await myFetch(
      `validate-number?phoneNumber=${phoneNumber}`,
      { method: "GET" }
    );
    const jsonResponse = await response.json();

    if (jsonResponse.remaining_seconds) {
      setTimer(jsonResponse.remaining_seconds);
    } else {
      setTimer(120);
    }
    setLoading(false);
    setShowVerification(true);
  };

  const handleVerifyCode = async (event) => {
    event.preventDefault();
    setLoading(true);
    // validate verification code
    if (!verificationCode) {
      setLoading(false);
      setVarificationCodeError("کد رو وارد نمیکنی؟");
      return;
    }

    setLoading(true);
    const response = await myFetch(
      `verify-code?phoneNumber=${phoneNumber}&code=${verificationCode}`,
      { method: "GET" }
    );
    const jsonResponse = await response.json();

    // validate verification code format
    if (!jsonResponse.verified) {
      setLoading(false);
      setVarificationCodeError(jsonResponse.message);
      return;
    }
    setLoading(true);
    localStorage.setItem("token", jsonResponse.token);
    localStorage.setItem("userInfo", JSON.stringify(jsonResponse.user_info));
    setIsVerified(true);
    stopTimer(); // stop the timer
  };

  const stopTimer = () => {
    setTimer(0);
  };

  useEffect(() => {
    let interval;
    if (timer > 0 && showVerification) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [showVerification, timer]);

  return (
    <div className="backPurple">
      <LoginIllus alt="loginIllus"></LoginIllus>
      <div className="bottom-container">
        {!isVerified ? (
          <form
            onSubmit={
              showVerification ? handleVerifyCode : handleSendVerification
            }
          >
            {!showVerification && (
              <>
                <div className="gap2">
                  <div>
                    <h2 className="font-semibold text-xl">ورود یا ثبت‌نام</h2>
                    <p className="grey-2">
                      شماره‌ت رو وارد کن تا به حساب کاربری‌ت برسی :
                    </p>
                    <div>
                      <input
                        type="tel"
                        value={phoneNumber}
                        onChange={handlePhoneChange}
                        placeholder="مثلا 09123456789"
                        className="inputField"
                      />
                      {phoneNumberError && (
                        <p className="error">{phoneNumberError}</p>
                      )}
                    </div>
                  </div>
                  <div>
                    <p className="grey-2 yekan caption-1">
                      {" "}
                      با ورود به{" "}
                      <Link
                        to="/policyprivacy"
                        className="link yekan caption-1"
                      >
                        شرایط و ضوابط و حریم خصوصی
                      </Link>{" "}
                      را قبول کرده‌اید{" "}
                    </p>
                  </div>
                  <div>
                    <button
                      type="submit"
                      className="primaryPurple"
                      disabled={loading}
                    >
                      {loading ? "در حال پردازش..." : "فرستادن کد"}
                    </button>
                  </div>
                </div>
              </>
            )}

            {showVerification && (
              <>
                <div className="gap5">
                  <div>
                    <h2 className="grey-1">کد تایید</h2>
                    <p className="grey-2">
                      کد تایید 5 رقمی فرستاده شده به {phoneNumber} رو اینجا وارد
                      کن :
                    </p>
                    <div className="marginBottom1-5r">
                      <input
                        type="text"
                        value={verificationCode}
                        onChange={handleVerificationCodeChange}
                        placeholder="_     _     _     _     _"
                        className="inputField"
                      />
                      {varificationCodeError && (
                        <p className="error">{varificationCodeError}</p>
                      )}
                    </div>

                    {timer > 0 && (
                      <p className="grey-2 centerAlign">
                        {Math.floor(timer / 60)}:
                        {timer % 60 < 10 ? "0" + (timer % 60) : timer % 60}{" "}
                        دقیقه تا فرستادن دوباره کد
                      </p>
                    )}
                    {timer === 0 && (
                      <Link
                        to=""
                        onClick={handleSendVerification}
                        className="link"
                      >
                        فرستادن دوباره کد
                      </Link>
                    )}
                  </div>
                  <div className="centerd">
                    <Link
                      onClick={() => (
                        setShowVerification(false),
                        setLoading(false),
                        setPhoneNumberError(false)
                      )}
                      to="/login"
                      className="link centerAlign"
                    >
                      شماره رو میخوای تغییر بدی؟ اینجا کلیک کن
                    </Link>
                    <button
                      type="submit"
                      className="primaryPurple"
                      disabled={loading}
                    >
                      {loading ? "در حال پردازش..." : "تایید و ادامه "}
                    </button>
                  </div>
                </div>
              </>
            )}
          </form>
        ) : localStorage.getItem(PENDING_INVITE_KEY) ? (
          // a group invitation was opened before login/signup - resume it
          navigate(`/group/invite/${localStorage.getItem(PENDING_INVITE_KEY)}`, { replace: true })
        ) : location.state?.from && location.state.from.pathname !== "/menu" ? (
          navigate(location.state.from)
        ) : (
          navigate("/")
        )}
      </div>
      <GoToTop />
    </div>
  );
}

export default Login;
